<template>
  <div style="width: 1114px;">
    <el-table
      class="custom-time-table"
      border
      :cell-style="{ padding: 0 }"
      :header-cell-style="{ textAlign: 'center',color: '#1D2129',padding: 0, border: '1px solid #E6EBF2', backgroundColor: '#F2F3F5', height: '30px' }"
      :data="days"
      style="width: 1108px;margin: auto;border-radius: 8px 8px 0 0"
    >
      <!-- 星期列 + 全选 -->
      <el-table-column label="周/时" width="99" fixed align="center">
        <template #default="{ $index }">
          <el-checkbox
            v-model="checkboxStates[$index].checked"
            :indeterminate="checkboxStates[$index].indeterminate"
            style="color: #1D2129"
            @change="onCheckboxChange"
          >
            {{ days[$index] }}
          </el-checkbox>
        </template>
      </el-table-column>

      <!-- 每小时一列 -->
      <el-table-column
        v-for="(hour, hIndex) in hours"
        :key="hIndex"
        :label="hour + ''"
        width="42"
      >
        <template #default="{ $index }">
          <div class="cell-box-row">
            <div
              class="cell-box"
              :class="getCellClass($index, hIndex * 2)"
              @mousedown.prevent="handleMouseDown($index, hIndex * 2)"
              @mouseenter="handleMouseEnter($index, hIndex * 2)"
            ></div>
            <div
              class="cell-box"
              :class="getCellClass($index, hIndex * 2 + 1)"
              @mousedown.prevent="handleMouseDown($index, hIndex * 2 + 1)"
              @mouseenter="handleMouseEnter($index, hIndex * 2 + 1)"
            ></div>
          </div>
        </template>
      </el-table-column>
    </el-table>

<!--    <el-button @click="alltime">打印已选时间</el-button>-->
    <div style="width: 1108px;border: 1px solid #E6EBF2;border-top: none;;margin: auto;padding: 0 5px;border-radius: 0 0 8px 8px">
      <div style="display: flex;justify-content: space-between">
        <div>已选时间段</div>
        <div style="cursor: pointer;color: #409EFF" @click="clearAll">清空</div>
      </div>
      <div v-for="(text, index) in formattedTextList" :key="index">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data() {
    return {
      days: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      hours: Array.from({ length: 24 }, (_, i) => i),
      selected: Array(7).fill().map(() => Array(48).fill(false)),
      hoverCell: { day: -1, hour: -1 },
      isMouseDown: false,
      dragStart: null,
      dragEnd: null,
      formattedTextList: []
    }
  },
  computed: {
    checkboxStates() {
      return this.selected.map((row, index) => {
        const all = row.every(v => v)
        const some = row.some(v => v)
        return {
          get checked() {
            return all
          },
          get indeterminate() {
            return !all && some
          },
          set checked(val) {
            for (let i = 0; i < 48; i++) {
              // 这里保证响应式
              Vue.set(row, i, val)
            }
          }
        }
      })
    }
  },
  methods: {
    emitSelected() {
      this.$emit('update-selected', this.selected)
    },
    getCellClass(dayIndex, halfHourIndex) {
      const isSelected = this.selected[dayIndex][halfHourIndex]
      const isHover = this.hoverCell.day === dayIndex && this.hoverCell.hour === halfHourIndex

      let inDragRange = false
      if (this.isMouseDown && this.dragStart && this.dragEnd) {
        const minDay = Math.min(this.dragStart.day, this.dragEnd.day)
        const maxDay = Math.max(this.dragStart.day, this.dragEnd.day)
        const minHour = Math.min(this.dragStart.hour, this.dragEnd.hour)
        const maxHour = Math.max(this.dragStart.hour, this.dragEnd.hour)
        inDragRange =
          dayIndex >= minDay &&
          dayIndex <= maxDay &&
          halfHourIndex >= minHour &&
          halfHourIndex <= maxHour
      }

      return {
        selected: isSelected,
        hover: isHover,
        'drag-highlight': inDragRange
      }
    },
    isIndeterminate(dayIndex) {
      const row = this.selected[dayIndex]
      return !row.every(v => v) && row.some(v => v)
    },
    handleMouseDown(day, hour) {
      this.isMouseDown = true
      this.dragStart = { day, hour }
      this.dragEnd = { day, hour }
    },
    handleMouseEnter(day, hour) {
      if (this.isMouseDown) {
        this.dragEnd = { day, hour }
      }
      this.hoverCell = { day, hour }
    },
    handleMouseUp() {
      if (!this.isMouseDown || !this.dragStart || !this.dragEnd) return

      const { day: d1, hour: h1 } = this.dragStart
      const { day: d2, hour: h2 } = this.dragEnd
      const minDay = Math.min(d1, d2)
      const maxDay = Math.max(d1, d2)
      const minHour = Math.min(h1, h2)
      const maxHour = Math.max(h1, h2)

      const baseState = !this.selected[d1][h1] // 以起点格状态为基准

      for (let day = minDay; day <= maxDay; day++) {
        for (let hour = minHour; hour <= maxHour; hour++) {
          this.$set(this.selected[day], hour, baseState)
        }
      }

      this.emitSelected()
      this.isMouseDown = false
      this.dragStart = null
      this.dragEnd = null
      this.formattedTextList = this.formatSelectedReadable()
    },
    formatSelectedReadable() {
      const result = []
      const toTimeStr = (halfHour) => {
        const hour = Math.floor(halfHour)
        const minute = halfHour % 1 === 0 ? '00' : '30'
        return `${hour}:${minute}`
      }

      this.days.forEach((day, dayIndex) => {
        const selectedRow = this.selected[dayIndex]
        const segments = []

        let start = null
        for (let i = 0; i <= 48; i++) {
          const val = selectedRow[i]
          const nextVal = selectedRow[i + 1]

          if (val && start === null) {
            start = i
          }

          const isSegmentEnd = start !== null && (!val || i === 47 || !nextVal)
          if (isSegmentEnd) {
            const end = i
            segments.push(`${toTimeStr(start * 0.5)}-${toTimeStr((end + 1) * 0.5)}`)
            start = null
          }
        }

        if (segments.length > 0) {
          result.push(`${day}：${segments.join(', ')}`)
        }
      })

      return result
    },
    onCheckboxChange() {
      this.formattedTextList = this.formatSelectedReadable()
      this.emitSelected()
    },
    clearAll() {
      for (let day = 0; day < this.selected.length; day++) {
        for (let hour = 0; hour < this.selected[day].length; hour++) {
          this.$set(this.selected[day], hour, false)
        }
      }
      this.formattedTextList = []
      this.emitSelected()
    }
  },
  mounted() {
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.handleMouseUp)
  }
}
</script>

<style lang="less" scoped>
.custom-time-table ::v-deep .cell {
  padding: 0 !important;
}

.cell-box-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 34px;
}

.cell-box {
  flex: 1;
  height: 100%;
  background-color: #fff;
  border: 0.01px solid #eee;
  border-bottom: none;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.cell-box.hover {
  background-color: rgba(0, 0, 255, 0.08);
}

.cell-box.selected {
  background-color: #3b82f6;
}

.cell-box.selected.hover {
  background-color: #2563eb;
}

.cell-box.drag-highlight {
  background-color: rgba(59, 130, 246, 0.25);
}

/* 表格去除间隙 */
.custom-time-table td.el-table__cell,
.custom-time-table th.el-table__cell {
  padding: 0 !important;
}

/* 可选：隔行换色 */
.custom-time-table .el-table__body tr td {
  background-color: #f0f9eb;
}
.custom-time-table .el-table__body tr:nth-child(even) td {
  background-color: #e1f3d8;
}

</style>
